import React, { useEffect } from "react";
import { useCheckBlocked } from "../hooks/useCheckBlocked";

interface IAllowedContext {
    BrowserFingerprint: string;
    IPAddress: string;
}

interface ICheckBlockedProps {
    onAllowed: (context: IAllowedContext) => void;
}
export const CheckBlocked = ({ onAllowed }: ICheckBlockedProps) => {
    const { data, isLoading, isError } = useCheckBlocked();

    useEffect(() => {
        if (
            data !== undefined &&
            typeof data === "object" &&
            "Valid" in data &&
            (data as any).Valid === true
        ) {
            const validData = data as {
                Valid: boolean;
                BrowserFingerprint: string;
                IPAddress: string;
            };

            onAllowed({
                BrowserFingerprint: validData.BrowserFingerprint,
                IPAddress: validData.IPAddress,
            });
        }
    }, [data, onAllowed]);

    if (isLoading) {
        return <p>Checking access...</p>;
    }

    if (isError || data === false) {
        return (
            <p className="error">
                Access denied. Your IP or browser fingerprint is blocked.
            </p>
        );
    }

    return null;
};
